module.exports = __webpack_public_path__ + "static/media/logo_blue.e4a731dc.png";